<div [ngClass]="{red_alert: hashNotEqual}" class="whitebox pricecheck-box">
  <!-- disabled temporarily for issue #1270, hashNotEqual -->
  <h3>Artikel Kalkulation</h3>

  <form [formGroup]="form">
    @if (false) {
      <div class="pricecheck-box-row">
        <!-- disabled temporarily for issue #1270, originally hashNotEqual -->
        <div class="pricecheck-box-col-100">
          <i class="fa fa-exclamation-triangle"></i> Artikeländerung. Kalkulation muss freigegeben werden.
        </div>
      </div>
    }


    <div class="pricecheck-box-row">
      <div class="pricecheck-box-col-50">
        <label for="id_germany">Kalkulation DE:</label>
      </div>
      <div class="pricecheck-box-col-50">
        <label for="id_china">Kalkulation CHN:</label>
      </div>
    </div>

    <div class="pricecheck-box-row">
      <div class="pricecheck-box-col-50">
        @if ('price.change'|HasPerm) {
          <price-selector name="de" [form]="form" [processes]="processes.de"
            id="id_germany">
          </price-selector>
        }
        @if (!('price.change'|HasPerm)) {
          <span>{{ article.calc_de }}</span>
        }
      </div>

      <div class="pricecheck-box-col-50">
        @if ('price.change'|HasPerm) {
          <price-selector name="cn" [form]="form" [processes]="processes.cn"
            id="id_china">
          </price-selector>
        }
        @if (!('price.change'|HasPerm)) {
          <span>{{ article.calc_chn }}</span>
        }
      </div>
    </div>

    <div class="pricecheck-box-row">
      <div class="pricecheck-box-col-50">
        @if ('price.change'|HasPerm) {
          <button (click)="overwriteCalc()" class="btn btn-default btn-sm"
            style="width: 100%;margin-top: 5px;"
            type="button">
            Speichern
          </button>
        }
      </div>

      @if (false) {
        <div class="pricecheck-box-col-50"> <!-- disabled temporarily for issue #1270 -->
          @if ('price.change'|HasPerm) {
            <button (click)="calc()" class="btn btn-warning btn-sm"
              style="width: 100%;margin-top: 5px;"
              type="button">
              Freigeben
            </button>
          }
        </div>
      }
    </div>

    @if (false) {
      <div class="pricecheck-box-row" style="margin-top:10px;">
        <!-- disabled temporarily for issue #1270 -->
        <div class="pricecheck-box-col-100">
          <strong>Achtung:</strong> Wenn Kalkulationen freigegeben werden, können Preise mit
          dieser Kalkulation
          in Aufträgen bestätigt werden, auch wenn diese nicht in der Preisliste enthalten sind.
        </div>
      </div>
    }

  </form>

</div>
